// Centralized API base URL
// In production (custom domain), use relative path so requests go to same origin
// In preview/dev, use the full REACT_APP_BACKEND_URL
var backendUrl = process.env.REACT_APP_BACKEND_URL || '';
var API = backendUrl ? backendUrl + '/api' : '/api';
var WS_BASE = backendUrl ? backendUrl.replace(/^http/, 'ws') : (typeof window !== 'undefined' ? window.location.origin.replace(/^http/, 'ws') : '');

export default API;
export { backendUrl as BACKEND_URL, WS_BASE };
